<div class="dialog--informal dialog__container">
  <div class="dialog__header" *ngIf="title">
    {{ title }}
  </div>
  <div class="dialog__header" *ngIf="!title">
    {{ "webPos.Done" | translate }}
  </div>
  <div class="dialog__content">
    <fa-icon
      *ngIf="type === PopUpInformalType.Error"
      class="dialog__icon dialog__icon--error"
      [icon]="['fas', 'circle-exclamation']">
    </fa-icon>
    <fa-icon
      *ngIf="type === PopUpInformalType.Success"
      class="dialog__icon dialog__icon--success"
      [icon]="['fas', 'circle-check']">
    </fa-icon>
    <fa-icon
      *ngIf="type === PopUpInformalType.Info"
      class="dialog__icon dialog__icon--info"
      [icon]="['fas', 'circle-info']">
    </fa-icon>

    <span *ngIf="message" class="dialog__message">
      {{ message }}
    </span>
    <span *ngIf="subMessage" class="dialog__message">
      {{ subMessage }}
    </span>


    <div *ngIf="showSendReceiptByEmail" class="dialog__checkbox-container stacked">
      <mat-checkbox [(ngModel)]="sendReceiptByEmail" color="primary">
        {{ 'webPos.SendReceiptByEmail' | translate }}
      </mat-checkbox>
      <app-form-input 
        *ngIf="sendReceiptByEmail" 
        class="dialog__receipt-email"
        [label]="'webPos.Email' | translate" 
        [type]="FormInputType.Email"
        [(ngModel)]="email" 
        appSelectAllOnFocus>
        <!-- TODO: Select all on focus directive not working here -->
      </app-form-input>
    </div>
   
    <div *ngIf="showPrintReceipt" class="dialog__checkbox-container">
      <mat-checkbox [(ngModel)]="printReceipt" color="primary">
        {{ 'webPos.PrintReceipt' | translate }}
      </mat-checkbox>
    </div>

    <div *ngIf="autoCloseSecondsRemaining !== null && autoCloseSecondsRemaining > 0" class="dialog__auto-close-note">
      {{ 'webPos.DialogAutoCloseCountdown' | translate:{ seconds: autoCloseSecondsRemaining } }}
    </div>
  </div>
  <div class="dialog__footer">
    @if (showCancelButton) {
    <app-action-button
      [buttonType]="ActionButtonType.Cancel"
      (click)="onCancel()">
      {{ resolvedCancelButtonText | translate }}
    </app-action-button>
    }

    <app-action-button 
      [buttonType]="ActionButtonType.Primary"
      [disabled]="isConfirmDisabled()"
      (click)="onConfirm()">
      {{ resolvedConfirmButtonText | translate }}
    </app-action-button>
  </div>
</div>
